<script setup lang="ts">
import mdiBookmark from '~icons/mdi/bookmark'

defineProps<{ percent: number }>()
</script>

<template>
  <div class="position-absolute top-0 right-0 d-flex flex-column align-center justify-center mx-2">
    <v-icon
      :icon="mdiBookmark"
      color="error"
      size="90"
      class="position-absolute"
    />
    <span
      class="text-white font-weight-bold text-body-1"
      style="z-index: 2;"
    >
      -{{ percent }}%
    </span>
  </div>
</template>
